import { ContactDialogConfig } from "@/lib/nemmp/base";

export const contactDialogConfig: ContactDialogConfig = {
  intro: `I'm looking forward to your questions, feedback or feature requests.`,
};
